module.exports = __webpack_public_path__ + "media/images/area/icon_weather_4-61deeadf274aabc8d87dc8e77f0e9fc9.png";